import React from 'react'
import PropTypes from 'prop-types'

import { Tooltip } from 'react-wot-bootstrap'
import { toRoman } from 'helpers'

import { getMinutesFormat } from 'helpers/datetime'

import { UNIT_TYPES, BATTLE_ROOMS_TAB_STATES } from 'constants'
import {
    LEVEL_FILTER_TOOLTIP_TITLE,
    LEVEL_FILTER_TOOLTIP_DESCRIPTION,
    LEVEL_FILTER_TOOLTIP_FILTER_ACTIONS,
} from './constants.jsx'

import { FORT_BATTLES } from 'helpers/i18n.jsx'

import styles from './LevelFilterTooltip.scss'

export class LevelFilterTooltip extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        battleRegulations : PropTypes.shape({
            unit_type: PropTypes.oneOf([
                UNIT_TYPES.SORTIE, UNIT_TYPES.FORT_BATTLE,
            ]),
            min_players_number: PropTypes.number,
            max_players_number: PropTypes.number,
            min_vehicle_level: PropTypes.number,
            max_vehicle_level: PropTypes.number,
            max_legionaries_number: PropTypes.number,
            battle_duration: PropTypes.number,
        }).isRequired,
        tab: PropTypes.oneOf(Object.values(BATTLE_ROOMS_TAB_STATES)).isRequired,
    }

    getVehicleLevels({ min_vehicle_level, max_vehicle_level }) {
        return min_vehicle_level === max_vehicle_level ?
            toRoman(max_vehicle_level) :
            `${toRoman(min_vehicle_level)}-${toRoman(max_vehicle_level)}`
    }

    getPlayersNumber({ min_players_number, max_players_number }) {
        return min_players_number === max_players_number ?
            max_players_number :
            `${min_players_number}-${max_players_number}`
    }

    render() {
        const battleRegulationsFormatted = {
            vehicleLevels: this.getVehicleLevels(this.props.battleRegulations),
            playersNumber: this.getPlayersNumber(this.props.battleRegulations),
            legionariesNumber: this.props.battleRegulations.max_legionaries_number,
            battleDuration: getMinutesFormat(this.props.battleRegulations.battle_duration / 60),
        }

        const battleRegulations = Object.keys(battleRegulationsFormatted).map((key, index) => (
            <div key={index} className={styles.detailsItem}>
                <span className={styles.value}>{battleRegulationsFormatted[key]}</span>
                <span className={styles.description}>{LEVEL_FILTER_TOOLTIP_DESCRIPTION[key]}</span>
            </div>
        ))

        const title = this.props.battleRegulations.unit_type === UNIT_TYPES.FORT_BATTLE ?
            FORT_BATTLES :
            LEVEL_FILTER_TOOLTIP_TITLE(toRoman(this.props.battleRegulations.max_vehicle_level))

        const content = (
            <div className={styles.base}>
                <p className={styles.title}>
                    {title}
                </p>
                <div className={styles.details}>
                    {battleRegulations}
                </div>
                <div className={styles.divider} />
                <p className={styles.message}>
                    {LEVEL_FILTER_TOOLTIP_FILTER_ACTIONS[this.props.tab]}
                </p>
            </div>
        )

        return (
            <Tooltip id={this.props.id} isWide>
                <div className={styles.content}>
                    {content}
                </div>
            </Tooltip>
        )
    }
}

export default LevelFilterTooltip



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/LevelFilterTooltip/LevelFilterTooltip.jsx